export default __webpack_public_path__ + "static/Plots0004-e5aabd90ade59d6529fb81c828cbc01b.jpg";